import React from "react";
import { graphql } from "gatsby";
import Button from "../base/button.js";
import TopBarIcons from "../icons/topBarIcons";
import IconAndImageCard from "./iconAndImageCard.js";
import { kebabCase } from "../../utilities/helper.js";
import { useCollectAnchorLinks } from "../../context/anchorLinksContextProvider";

const CardList = ({ cardList, blockIndex }) => {
  const Anchor = cardList.anchor ?? kebabCase(cardList.heading) ?? cardList.id;
  const title = cardList.heading ? <h2>{cardList.heading}</h2> : <h2 className="sr-only">Card list section</h2>;

  useCollectAnchorLinks(cardList.heading, cardList?.anchor, blockIndex);

  const button =
    cardList.buttonLink && cardList.buttonText ? (
      <Button
        href={cardList.buttonLink}
        type={`btn-${cardList.buttonType ? cardList.buttonType : "tertiary-small"}`}
        text={cardList.buttonText}
        target="_self"
      >
        {cardList.buttonType === "arrow-right" && (
          <>
            {" "}
            <TopBarIcons name="arrow-right" />
          </>
        )}
      </Button>
    ) : (
      ""
    );

  return cardList.cardList.length > 0 ? (
    <section className={`card-list${cardList.divider ? " divider" : ""}`} id={Anchor}>
      <div className="card-list--wrapper">
        {title}
        <div className="card-list--wrapper__container">
          {cardList.cardList.map((card, index) => {
            return (
              <IconAndImageCard
                key={`card-list-${index}`}
                cardImage={card.cardImage}
                title={card.title}
                copy={card.copy}
                buttonType={card.buttonType}
                buttonText={card.buttonText}
                link={card.link}
                objectFit={card.objectFit}
              />
            );
          })}
        </div>
        {button}
      </div>
    </section>
  ) : (
    ""
  );
};

export default CardList;

export const query = graphql`
  fragment CardList on ContentfulCardList {
    id
    anchor
    buttonLink
    buttonText
    buttonType
    heading
    cardList {
      ...IconAndImageCard
    }
    buttonText
    buttonLink
    buttonType
    divider
  }
`;
